module.exports = __webpack_public_path__ + "img/img_kb_type4_03.b3e71755.png";